import {
  WalletAlertLevel,
  WalletAlertProcessingStatus,
  WalletAlertSource,
  WalletAlertWalletType,
} from './types'

export const SOURCE_LABELS: Record<WalletAlertSource, string> = {
  ADDRESS: 'Адрес кошелька',
  TRANSACTION: 'Транзакция',
}

export const LEVEL_LABELS: Record<WalletAlertLevel, string> = {
  SUSPICIOUS: 'Подозрительный',
  DANGEROUS: 'Опасный',
}

export const LEVEL_COLORS: Record<WalletAlertLevel, string> = {
  SUSPICIOUS: 'warning',
  DANGEROUS: 'error',
}

export const PROCESSING_STATUS_LABELS: Record<
  WalletAlertProcessingStatus,
  string
> = {
  PENDING: 'На проверке',
  FALSE_POSITIVE: 'Ложная тревога',
  BLOCKED: 'Заблокировано',
}

export const PROCESSING_STATUS_COLORS: Record<
  WalletAlertProcessingStatus,
  string
> = {
  PENDING: 'processing',
  FALSE_POSITIVE: 'success',
  BLOCKED: 'default',
}

export const WALLET_TYPE_LABELS: Record<WalletAlertWalletType, string> = {
  SENDER: 'Отправитель',
  TRANSIT: 'Транзитный',
  FINAL: 'Финальный',
  OWN: 'Свой',
}

export const SOURCE_OPTIONS = [
  { value: 'address', label: SOURCE_LABELS.ADDRESS },
  { value: 'transaction', label: SOURCE_LABELS.TRANSACTION },
]

export const LEVEL_OPTIONS = [
  { value: 'suspicious', label: LEVEL_LABELS.SUSPICIOUS },
  { value: 'dangerous', label: LEVEL_LABELS.DANGEROUS },
]
